import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../styles/components/videoReleaseModal.module.scss";
// import Image from 'next/image'
import assest from "../../json/assest";
import VideoReleaseAssetsModal from "../VideoReleaseAssetsModal/VideoReleaseAssetsModal";
import ModalWrapperVideoAssets from "../../ui/ModalWrapper/ModalWrapperVideoAssets";
import ModalWrapperMedium from "../../ui/ModalWrapper/ModalWrapperMedium";
import { getCurrentUTCDateTime } from "../../lib/functions/utils.lib";

const VideoReleaseModal = ({
  openVideoRelease,
  handleCloseVideoRelease,
  data,
}) => {
  const [openVideoReleaseAssests, setOpenVideoReleaseAssests] =
    React.useState(false);

  const [release_status, setRelease_status] = useState(null);
  const [utcDateTime, setUtcDateTime] = useState(getCurrentUTCDateTime());
  const handleClickOpenVideoReleaseAssests = () => {
    setOpenVideoReleaseAssests(true);
  };
  const handleCloseVideoReleaseAssests = () => {
    setOpenVideoReleaseAssests(false);
  };

  useEffect(() => {
    const timerId = setInterval(() => {
      setUtcDateTime(getCurrentUTCDateTime());
    }, 5000);

    return () => clearInterval(timerId);
  }, []);

  return (
    <ModalWrapperMedium
      open={openVideoRelease}
      onClose={handleCloseVideoRelease}
      handleClose={handleCloseVideoRelease}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={styles.messageModal}>
        <Box className={styles.messageModalHeader}>
          <h4>Video Release</h4>
          <p>
            <span>Date:</span> {utcDateTime}
          </p>
        </Box>

        <Box className={styles.messageModalBody}>
          <h4>Why would you like to release this video?</h4>
          <Box className={styles.videoReleaseBox}>
            <Button
              onClick={() => setRelease_status(1)}
              className={`${styles.videoReleseBosItem} ${
                release_status == 1 ? styles.videoReleseBosItemActive : ""
              }`}
            >
              <img src={assest.copyRighticon} width={43} height={43} alt="" />
              <h4>Copyright Dispute</h4>
            </Button>
            <Button
              onClick={() => setRelease_status(2)}
              className={`${styles.videoReleseBosItem} ${
                release_status == 2 ? styles.videoReleseBosItemActive : ""
              }`}
            >
              <img
                src={assest.somethingElseIcon}
                width={43}
                height={43}
                alt=""
              />
              <h4>Something Else</h4>
            </Button>
          </Box>
        </Box>

        <Box className={styles.messageModalFooter}>
          <Button onClick={handleCloseVideoRelease}>Cancel</Button>
          <Button
            className={styles.active}
            onClick={handleClickOpenVideoReleaseAssests}
          >
            Confirm
          </Button>
        </Box>

        {/* <ModalWrapperVideoAssets
          open={openVideoReleaseAssests}
          onClose={handleCloseVideoReleaseAssests}
          handleClose={handleCloseVideoReleaseAssests}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        > */}
        <VideoReleaseAssetsModal
          openVideoReleaseAssests={openVideoReleaseAssests}
          handleCloseVideoReleaseAssests={handleCloseVideoReleaseAssests}
          handleCloseVideoRelease={handleCloseVideoRelease}
          data={data}
          release_status={release_status}
        />
        {/* </ModalWrapperVideoAssets> */}
      </Box>
    </ModalWrapperMedium>
  );
};

export default VideoReleaseModal;
